import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';

import { useUploadPdfButton } from './hooks';

function UploadPdfButton({ className, children, ...props }) {
	const { t } = useTranslation();

	const { inputProps, onClick, loading } = useUploadPdfButton();

	return (
		<>
			<Button
				className={className}
				onClick={onClick}
				loading={loading}
				{...props}
			>
				{children || t('common.uploadPdfToConvert')}
			</Button>
			<input
				type="file"
				className="hidden"
				ref={inputProps.ref}
				aria-label={t('common.file')}
				accept={inputProps.accept}
				onChange={inputProps.onChange}
			/>
		</>
	);
}

export default UploadPdfButton;
